export const BLOCKED_TITLE = "Уведомления заблокированы в браузере";

export const BLOCKED_INTRO =
  "Чтобы получать уведомления о новых сообщениях, разрешите их для этого сайта в настройках браузера.";

export const BROWSER_INSTRUCTIONS = Object.freeze({
  chrome:
    "Нажмите значок слева от адреса сайта и включите «Уведомления». Затем обновите страницу.",
  yandex:
    "Нажмите значок слева от адреса сайта, включите «Уведомления» и нажмите «Обновить страницу».",
  edge:
    "Нажмите значок слева от адреса сайта, откройте разрешения для сайта и выберите «Разрешить» для уведомлений. Затем обновите страницу.",
  firefox:
    "Откройте Настройки → Приватность и защита → Разрешения. Напротив пункта «Уведомления» откройте настройки, найдите адрес сайта и выберите «Разрешить». Сохраните изменения и обновите страницу.",
  "safari-mac":
    "В меню Safari откройте Настройки → Веб-сайты → Уведомления. Найдите адрес сайта и выберите «Разрешить». Затем обновите страницу.",
  unknown:
    "Откройте настройки разрешений для этого сайта, разрешите уведомления и обновите страницу.",
});

const getNavigatorValue = (value, key) => {
  if (value != null) {
    return String(value);
  }

  if (typeof navigator !== "undefined") {
    return String(navigator[key] || "");
  }

  return "";
};

/**
 * Возвращает стабильный ключ браузера для выбора инструкции.
 * Порядок проверок важен: Edge и Яндекс Браузер также содержат маркеры Chrome.
 */
export function detectBrowser(userAgent, platform) {
  const ua = getNavigatorValue(userAgent, "userAgent");
  const browserPlatform = getNavigatorValue(platform, "platform");

  if (/Edg(?:A|iOS)?\//i.test(ua)) {
    return "edge";
  }

  if (/YaBrowser\//i.test(ua)) {
    return "yandex";
  }

  if (/(?:Firefox|FxiOS)\//i.test(ua)) {
    return "firefox";
  }

  const isMac = /Macintosh|MacIntel|MacPPC|Mac68K/i.test(
    `${ua} ${browserPlatform}`
  );
  const isSafari = /Safari\//i.test(ua);
  const isChrome = /(?:Chrome|CriOS)\//i.test(ua);

  if (isMac && isSafari && !isChrome) {
    return "safari-mac";
  }

  if (isChrome) {
    return "chrome";
  }

  return "unknown";
}

export function getBrowserInstruction(browser) {
  return BROWSER_INSTRUCTIONS[browser] || BROWSER_INSTRUCTIONS.unknown;
}
